import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {Grid,Box,TextField,useMediaQuery,Paper,Typography,Button,Skeleton,Card,CardContent,CardActions,Modal,IconButton,Switch,Divider,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EditIcon from "@mui/icons-material/Edit";
import ResponsiveAppBar from "../../../component/appbar";
import { MdAddCircleOutline } from "react-icons/md";
import { MdOutlineDateRange } from "react-icons/md";
import Cookies from 'js-cookie';
import { AlertError, AlertLoading, AlertSuccess } from "../../../component/popupAlert";
import { createSpecialDate, DeleteTimeSpecial, getSpecialDate, GetSpecialDateTime, getTimeSlots, getTimeSlotSpecialDay, UpdateTimeSlots, UpdateTimeSlotsAll } from "../../../service/utinity_service";
import { format } from 'date-fns';
import { th } from 'date-fns/locale';
import { StaticDatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TimeSlotsMock } from "../../../utility/timeslots";
import TimeSlotTable from "../../../component/timeTatble";
import DateCalendarServerRequest from "../../../component/test";

const BoatRentalPlanner = () => {

    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [selectedDateSpecial, setSelectedDateSpecial] = useState(new Date());
    const [timeSlots, setTimeSlots] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editAllModalOpen, setEditAllModalOpen] = useState(false);
    const [specialDayModalOpen, setSpecialDayModalOpen] = useState(false);
    const [stateSetValue, setStateValue] = useState("all");

    const [specialday, setSpecialDay] = useState([]);
    const peopleDefault = {
        people: 0,
        priceAdults: 0,
        priceChildren: 0,
        isActive: true,
    }

    const [people, setPeople] = useState(peopleDefault);

    const token = Cookies.get('token');

    const [defaultTimeSlots, setDefaultTimeSlots] = useState(TimeSlotsMock)

    useEffect(() => {
        if (!token) {
            navigate('/login');
        }
        handleCheckAvailability();
        handleGetSpecialDays();
    }, []);

    const handleCheckAvailability = async () => {
        setLoading(true);
        try {
            const response = await getTimeSlots(token);

            if (Array.isArray(response)) {
                setTimeSlots(response);
                setDefaultTimeSlots(JSON.parse(JSON.stringify(response)));
            } else {
                console.error("Invalid response structure:", response);
            }
        } catch (error) {
            console.error("Error checking boat availability:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleGetSpecialDays = async () => {
        try {
            const res = await getSpecialDate()
            setSpecialDay(res)
        } catch (error) {
            console.error("Error getting special day:", error);
            getSpecialDate([])
        }
    }

    const handleDeleteSpecial = async ()=>{
        setLoading(true);
        setSpecialDayModalOpen(false);
        try {
            const formattedDate = formatDate(selectedDateSpecial);
            const res = await DeleteTimeSpecial(formattedDate,token)
            await handleCheckAvailability();
            await handleGetSpecialDays();
            AlertSuccess('ลบข้อมูลสำเร็จ')
        } catch (error) {
            AlertError('เกิดข้อลบในการบันทึกวันพิเศษ', error);
        }
        setLoading(false);
    }

    const updateTotalPeople = () => {
        setDefaultTimeSlots(prevSlots => 
          prevSlots.map(slot => ({
            ...slot,
            total_people: people.people,
            price_adult: people.priceAdults,
            price_children: people.priceChildren,
            status :  people.isActive ? "active" : "inactive"
          }))
        );
      };

    const handleChange = (event) => {
        const { name, checked, type, value } = event.target;

        // Update the corresponding field in the state
        setPeople(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value, // update isActive or other fields
        }));
    };

    const handleSetSpecialDayModalOpen = async ()=>{
        setSpecialDayModalOpen(true);
        console.log("setSelectedDateSpecial : ", setSelectedDateSpecial)
        try {
            // const res = await GetSpecialDateTime()
        } catch (error) {
            
        }
    }

    const handleChangeTable = (index, field, value) => {
        // console.log(timeSlots)
        setTimeSlots(prevSlots => prevSlots.map((slot, i) =>
            i === index ? { ...slot, [field]: field === 'total_people' || field.startsWith('price_') ? parseFloat(value) || "" : value } : slot
        ));
    };

    const handleChangeSpecialDayTable = (index, field, value) => {
        // console.log(timeSlots)
        setDefaultTimeSlots(prevSlots => prevSlots.map((slot, i) =>
            i === index ? { ...slot, [field]: field === 'total_people' || field.startsWith('price_') ? parseFloat(value) || "" : value } : slot
        ));
    };

    const handleEditAll = () => {
        setEditAllModalOpen(true);
        setStateValue("all")
    };

    const handleEditSpecial = () => {
        setEditAllModalOpen(true);
        setStateValue("special")
    }

    const handleCloseSpecialDayModal = () => {
        setSpecialDayModalOpen(false);
    };

    const handleCloseEditAllModal = () => {
        setEditAllModalOpen(false);
    };

    const handleEditAllSubmit = async (type) => {
        // console.log(type)
        if (type === 'all') {
            if (people === undefined || people <= 0) {
                AlertError("เกิดข้อผิดพลาด", "ระบุจำนวนผู้โดยสาร");
                setEditAllModalOpen(false);
                return;
            }
    
            AlertLoading();
            setLoading(true);
            try {
                const res = await UpdateTimeSlotsAll(people, token)
                setEditAllModalOpen(false);
                AlertSuccess('แก้ไขข้อมูลสำเร็จ')
    
            } catch (err) {
                console.error('Error saving all data:', err);
                AlertError('Error saving all data:', err)
    
            }
            handleCheckAvailability();
        }else{
            updateTotalPeople()
            setEditAllModalOpen(false);
        }
        setLoading(false)
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // วันที่
        const month = String(date.getMonth() + 1).padStart(2, '0'); // เดือน (0-11)
        const year = date.getFullYear(); // ปี
        return `${day}-${month}-${year}`;
    }

    const handleSaveSpecialDay = async () => {
        setLoading(true);
        setSpecialDayModalOpen(false);
        try {
            const formattedDate = formatDate(selectedDateSpecial);
            // console.log('Special day data:', formattedDate, "specialDayData", defaultTimeSlots);
            const res = await createSpecialDate(token, formattedDate, defaultTimeSlots)

            await handleCheckAvailability();
            await handleGetSpecialDays();
        } catch (error) {
            console.error('Error saving special day: ', error);
            AlertError('เกิดข้อผิดพลาดในการบันทึกวันพิเศษ', error);
        }

        setLoading(false);
        AlertSuccess('บันทึกวันพิเศษสำเร็จ');
    };

    const handleDateSpecialChange = (newDate) => {
        console.log('newDate: ', newDate);
        setSelectedDateSpecial(newDate);
        handleGetTimeSlotSpecial(newDate)
    };

    const handleGetTimeSlotSpecial = async (newDate) => {
        try {
            const formattedDate = formatDate(newDate);
            // console.log(newDate);
            // console.log('formattedDate: ', formattedDate);
            
            const res = await getTimeSlotSpecialDay(formattedDate);
            
            if (res.length > 0) { // Corrected the typo here
                setDefaultTimeSlots(res);
            } else {
                console.log("res", res);
                setDefaultTimeSlots(timeSlots);
            }
        } catch (error) {
            console.error('Error getting time slots by date: ', error);
        }
    };

    const modalStyle = {
        position: "absolute",top: "50%",left: "50%",
        transform: "translate(-50%, -50%)",width: 400,
        maxHeight: "82vh",overflow: "auto",bgcolor: "background.paper",
        boxShadow: 24,p: 4,borderRadius: 2,
    };

    const renderEditAllModal = () => (
        <Modal
            open={editAllModalOpen}
            onClose={handleCloseEditAllModal}
            aria-labelledby="edit-all-modal"
            aria-describedby="modal-to-edit-all-slots"
        >
            <Box sx={modalStyle}>
                <Box sx={{ margin: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom>
                        แก้ไขข้อมูลทั้งหมด
                    </Typography>
                    <Divider />
                    <Box margin={1}>
                        <Grid item xs={12} md={6}>
                            <Typography>จำนวนผู้โดยสาร</Typography>
                            <Box margin={1}>
                                <TextField
                                    className='bookingTextField'
                                    name="people"
                                    fullWidth
                                    label="จำนวนผู้โดยสาร"
                                    variant="outlined"
                                    value={people.people}
                                    type="number"
                                    onChange={handleChange}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Typography>ราคา "ผู้ใหญ่"</Typography>
                            <Box margin={1}>
                                <TextField
                                    className='bookingTextField'
                                    name="priceAdults"
                                    fullWidth
                                    label="ราคา ผู้ใหญ่"
                                    variant="outlined"
                                    value={people.priceAdults}
                                    type="number"
                                    onChange={handleChange}
                                    InputProps={{
                                        endAdornment: (
                                            <Typography>
                                                บาท
                                            </Typography>
                                        ),
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Typography>ราคา "เด็ก"</Typography>
                            <Box margin={1}>
                                <TextField
                                    className='bookingTextField'
                                    name="priceChildren"
                                    fullWidth
                                    label="ราคา เด็ก"
                                    variant="outlined"
                                    value={people.priceChildren}
                                    type="number"
                                    onChange={handleChange}
                                    InputProps={{
                                        endAdornment: (
                                            <Typography>
                                                บาท
                                            </Typography>
                                        ),
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Box>

                    <Grid item xs={12} md={6}>
                        <Typography>การให้บริการ</Typography>
                        <Box margin={1} padding={1}>
                            <Card>
                                {/* Switch to toggle service status */}
                                <Switch
                                    name="isActive"
                                    checked={people.isActive}  // bind to the isActive state
                                    onChange={handleChange}    // update state on change
                                    inputProps={{ 'aria-label': 'Toggle Active' }}
                                />

                                {/* Conditionally render the text based on the isActive state */}
                                {people.isActive ? 'เปิดให้บริการ' : 'ยกเลิกการให้บริการ'}
                            </Card>
                        </Box>
                    </Grid>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 3 }}
                        onClick={(e)=>handleEditAllSubmit(stateSetValue)}
                    >
                        บันทึกทั้งหมด
                    </Button>
                </Box>
            </Box>
        </Modal>
    );

    const AddSpecialDayModal = () => (
        <Modal
            open={specialDayModalOpen}
            onClose={handleCloseSpecialDayModal}
            aria-labelledby="add-special-day-modal"
            aria-describedby="modal-to-add-special-day"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '98%',
                maxWidth: '1300px',
                maxHeight: '95vh',
                bgcolor: 'background.paper',
                boxShadow: 24,
                borderRadius: 2,
                overflow: 'auto',
            }}>
                <Box sx={{ m: 2 }}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 1 }}>
                        <MdOutlineDateRange style={{ marginRight: '4px', verticalAlign: "middle" }} />
                        เพิ่มวันพิเศษ
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Paper elevation={3} sx={{ p: 1, height: '100%', width: '100%' }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={th}>
                                    <StaticDatePicker
                                        value={selectedDateSpecial}
                                        onChange={handleDateSpecialChange}
                                        renderInput={(params) => <div {...params} />}
                                        sx={{ width: '100%' }}
                                    />
                                </LocalizationProvider>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Paper elevation={3} sx={{ marginLeft: 1, p: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
                                    เลือกรอบเวลา - {format(selectedDateSpecial, 'dd MMMM yyyy', { locale: th })}
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<EditIcon />}
                                        sx={{ mr: 1, width: '200px' }}
                                        onClick={handleEditSpecial}
                                    >
                                        แก้ไขทั้งหมด
                                    </Button>
                                </Box>
                                <Box sx={{ flexGrow: 1, overflowY: 'auto', maxHeight: '60vh', mt: 1 }}>
                                    <TimeSlotTable
                                        slots={defaultTimeSlots}
                                        handleChange={handleChangeSpecialDayTable}
                                    />
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                    <Box sx={{ mt: 6, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={handleCloseSpecialDayModal} sx={{ mr: 1, width: '120px' }} variant="outlined">
                            ยกเลิก
                        </Button>
                        <Button onClick={handleDeleteSpecial} variant="contained" color="error" sx={{ width: '120px',mr: 1,}}>
                            ยกเลิกวันพิเศษ
                        </Button>
                        <Button onClick={handleSaveSpecialDay} variant="contained" color="primary" sx={{ width: '120px' }}>
                            บันทึก
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await UpdateTimeSlots(timeSlots, token)
        } catch (error) {
            console.error('Error updating time slots:', error);
            AlertError('Error updating time slots:', error)
        }
        handleCheckAvailability()
        setLoading(false);
    };

    return (
        <Box>
            <ResponsiveAppBar />
            <Box sx={{ my: 4 }}>
                <Typography
                    variant="h4"
                    component="h1"
                    gutterBottom
                    align="center"
                    color="primary"
                >
                    Boat management system
                </Typography>
                <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sx={{ width: '100%' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={3}>
                                    <DateCalendarServerRequest 
                                    specialday={specialday} 
                                    setState={setSelectedDateSpecial} 
                                    setopen={setSpecialDayModalOpen} 
                                    data = {defaultTimeSlots}
                                    setData={setDefaultTimeSlots}
                                    datadefault={timeSlots}
                                />
                                </Grid>
                                <Grid item xs={12} md={9}>
                                    <Card elevation={2}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Typography variant="h6">
                                                    <AccessTimeIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                                                    แก้ไข สำหรับทุกวัน
                                                </Typography>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Box sx={{ margin: 1 }}>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<EditIcon />}
                                                            onClick={handleEditAll}
                                                        >
                                                            แก้ไขทั้งหมด
                                                        </Button>
                                                    </Box>
                                                    <Box sx={{ margin: 1 }}>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<MdAddCircleOutline />}
                                                            onClick={(e) => setSpecialDayModalOpen(true)}
                                                        >
                                                            เพิ่มวันพิเศษ
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            {loading ? (
                                                <Grid container spacing={2}>
                                                    {[...Array(20)].map((_, index) => (
                                                        <Grid item xs={6} sm={3} md={3} key={index}>
                                                            <Skeleton variant="rectangular" height={80} />
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            ) : (
                                                <TimeSlotTable
                                                    slots={timeSlots}
                                                    handleChange={handleChangeTable}
                                                />
                                            )}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Card
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            mb: 2,
                            mt: 2,
                            p: 2
                        }}
                    >
                        <Box sx={{ display: 'flex', }}>
                            <Button variant="outlined" sx={{ margin: 1, width: '200px' }} onClick={() => navigate('/thewonderblueadmin_admin')}>Back</Button>
                            <Button variant="contained" sx={{ margin: 1, width: '200px' }} onClick={(e) => handleSubmit(e)}>Save</Button>
                        </Box>
                    </Card>
                </Paper>
            </Box>
            {renderEditAllModal()}
            {AddSpecialDayModal()}
        </Box>
    );
};

export default BoatRentalPlanner;